export default __webpack_public_path__ + "static/media/SELLO_SEMILLAS_CERTIFICADAS_EN.8c905f61.png";